import React, { CSSProperties } from 'react'
import Text from '../../Common/Text'
import type { ISelectionRect } from '../hooks/useScreenshotCapture'
import styles from './RegionSelectOverlay.module.scss'

interface IProps {
  dragRect: ISelectionRect | null
  onMouseDown: (event: React.MouseEvent) => void
  onMouseMove: (event: React.MouseEvent) => void
  onMouseUp: () => void
}

// The drag-to-select layer over the whole screen. Marked as feedback UI, so captures skip it.
const RegionSelectOverlay = ({ dragRect, onMouseDown, onMouseMove, onMouseUp }: IProps) => (
  <div
    className={styles.overlay}
    data-feedback-widget
    onMouseDown={onMouseDown}
    onMouseMove={onMouseMove}
    onMouseUp={onMouseUp}
  >
    <div className={styles.hint}>
      <Text variant="bodySm" component="span">
        Drag to select an area to capture
      </Text>
    </div>
    {dragRect && (
      <div
        className={styles.selection}
        style={
          {
            '--region-x': `${dragRect.x}px`,
            '--region-y': `${dragRect.y}px`,
            '--region-width': `${dragRect.width}px`,
            '--region-height': `${dragRect.height}px`,
          } as CSSProperties
        }
      />
    )}
  </div>
)

export default RegionSelectOverlay
